import { ReactNode } from "react";
import { Filter, PropertyFilter, Range, RangeBound, Values } from "../../../types/types";
import { useDataTableContext } from "../../../contexts/DataTableContext";
import { Icon, Label } from "semantic-ui-react";
import { FilterType } from "../../../hooks/usePropertyFilters";

interface FilterPillProps {
	filter: Filter | PropertyFilter;
	onEdit: (filter: Filter | PropertyFilter) => void;
	onRemove: () => void;
}

export default function FilterPill({ filter, onEdit, onRemove }: FilterPillProps) {
	const { getFilterTypeFromAggregates, getFriendlyColumnName } = useDataTableContext()!;

	const type = "accessor" in filter ? getFilterTypeFromAggregates(filter.accessor) : FilterType.PATTERN;

	let children: ReactNode;

	switch (type) {
		case FilterType.RANGE:
		case FilterType.DATE_RANGE:
			const range = filter.term as Range;
			const coalesce = (value: RangeBound | null) => value?.toString() ?? "*";
			children = coalesce(range[0]) + " - " + coalesce(range[1]);
			break;

		case FilterType.VALUES:
			const values = filter.term as unknown as Values;
			children = values.join(", ");
			break;

		default:
			children = filter.term;
			break;
	}

	return (
		<Label horizontal>
			<span className="accessor">
				{getFriendlyColumnName("accessor" in filter ? filter.accessor : filter.attribute)}:{" "}
			</span>
			<span className="values">{children}</span>
			<span className="controls">
				<Icon name="pencil" onClick={() => onEdit(filter)} />
				<Icon name="remove" onClick={onRemove} />
			</span>
		</Label>
	);
}
